import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { unpack, reverse3 } from '../../utils/index.js';
import lch2rgb from './lch2rgb.js';
var hcl2rgb = function hcl2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var hcl = reverse3(unpack(args, 'hcl'));
  return lch2rgb.apply(void 0, _toConsumableArray(hcl));
};
export default hcl2rgb;